var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-item"},[_c('div',{staticClass:"footer-item__list"},[_c('p',[_vm._v("中國信託證券投資信託股份有限公司")]),_c('p',[_c('span',[_vm._v("台北總公司：台北市南港區經貿二路188號12樓 / 02-2652-6688")]),_c('span',[_vm._v("台中分公司：台中市西區忠明南路499號9樓之1 / 04-2372-5199")])])]),_c('div',{staticClass:"footer-item__list"},[_vm._v("©CTBCINVESTMENTS")])])])
}]

export { render, staticRenderFns }